import { useEffect, useState } from "react";
import { cn } from "../../lib/utils";
import { bgMap, ColorType, pureBgMap } from "../../shared/colors";
import { useInView } from "react-intersection-observer";

type LinearProgress2Props = {
  title: string;
  value: number;
  color: ColorType;
  pathWidth?: number;
};

const LinearProgress2 = ({
  title,
  value,
  color,
  pathWidth = 24,
}: LinearProgress2Props) => {
  const [counter, setCounter] = useState(0);
  const [done, setDone] = useState(false);
  const { ref: progressRef, inView: animate } = useInView();

  const startCount = () => {
    setDone(true);
    const interval = setInterval(() => {
      setCounter((p) => {
        const newCounter = p + 1;
        if (newCounter === value) {
          clearInterval(interval);
        }
        return newCounter;
      });
    }, 2000 / value);
  };

  useEffect(() => {
    if (animate && !done) {
      startCount();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animate, done]);

  if (pathWidth < 24) pathWidth = 24;

  return (
    <div ref={progressRef} className="text-sm">
      <h3 className="mb-2 font-semibold text-[--title]">{title}</h3>
      <div
        className={cn("w-full rounded-e-sm relative", bgMap[color])}
        style={{ height: pathWidth }}
      >
        <div
          className={cn("absolute h-full rounded-e-sm", pureBgMap[color])}
          style={{
            transition: "2s ease-in-out",
            width: `${animate ? value : 0}%`,
          }}
        >
          <div className="absolute right-2 top-[50%] translate-y-[-50%] text-white font-semibold">
            {counter}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default LinearProgress2;
